module.exports = __webpack_public_path__ + "img/1.50e3fc1b.png";